var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',{attrs:{"label":_vm.$t('info_card.passport_number'),"placeholder":_vm.$t('info_card.passport_number'),"rules":_vm.passportNumberRules,"outlined":"","dense":"","disabled":_vm.disabled},model:{value:(_vm.inputValue),callback:function ($$v) {_vm.inputValue=$$v},expression:"inputValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }